<template>
  <div class="account-form-coach-skills">
    <p>
      Bitte laden Sie hier Unterlagen zu Ihrer Ausbildung sowie Zertifikate hoch
      – gebündelt jeweils in einer PDF-Datei. Wenn Sie Ihre Unterlagen
      aktualisieren oder austauschen möchten, laden Sie bitte einfach erneut ein
      gebündeltes PDF über den Button „Datei auswählen“ hoch und klicken
      anschließend auf „Speichern“.
    </p>

    <el-form-item
      for="training"
      label="Unterlagen zur Ausbildung (max. 4 MB)"
      prop="documentsTraining"
    >
      <el-input
        id="training"
        ref="training"
        accept="application/pdf"
        type="file"
        @change="handleTrainingChange"
      >
        <template slot="append">
          PDF
        </template>
      </el-input>
    </el-form-item>

    <el-alert
      v-if="temp.documentTraining"
      :closable="false"
      type="success"
    >
      Aktuelle Unterlagen:
      <a
        :download="temp.documentTraining.filename"
        :href="temp.documentTraining.url"
        target="_blank"
      >
        {{ temp.documentTraining.filename }}
      </a>
    </el-alert>

    <el-form-item
      for="certificate"
      label="Zertifikate (max. 4 MB)"
      prop="documentsCertificate"
    >
      <el-input
        id="certificate"
        ref="certificate"
        accept="application/pdf"
        type="file"
        @change="handleCertificateChange"
      >
        <template slot="append">
          PDF
        </template>
      </el-input>
    </el-form-item>

    <el-alert
      v-if="temp.documentCertificate"
      :closable="false"
      type="success"
    >
      Aktuelle Zertifikate:
      <a
        :download="temp.documentCertificate.filename"
        :href="temp.documentCertificate.url"
        target="_blank"
      >
        {{ temp.documentCertificate.filename }}
      </a>
    </el-alert>

    <el-form-item
      for="compensation"
      label="Vergütung pro Stunde in Euro (netto)"
      prop="compensation"
    >
      <el-input
        id="compensation"
        v-model.number="form.compensation"
        min="0"
        step="0.01"
        type="number"
      >
        <template slot="append">
          € / Stunde
        </template>
      </el-input>
    </el-form-item>

    <el-form-item
      for="website"
      label="Website"
      prop="website"
    >
      <el-input
        id="website"
        v-model="form.website"
        type="url"
        placeholder="https://beispiel.de"
      />
    </el-form-item>

    <el-form-item
      for="core-area"
      label="Thematische Schwerpunkte"
      prop="coreArea"
    >
      <el-input
        id="core-area"
        v-model="form.coreArea"
        :autosize="{ minRows: 4, maxRows: 22 }"
        maxlength="2000"
        type="textarea"
      />
    </el-form-item>

    <el-form-item prop="membershipsBvc">
      <el-checkbox
        v-model="form.membershipsBvc"
        border
      >
        Ich bin Mitglied im Bundesverband Coaching.
      </el-checkbox>
    </el-form-item>

    <el-form-item prop="membershipsBvs">
      <el-checkbox
        v-model="form.membershipsBvs"
        border
      >
        Ich bin Mitglied im Bundesverband Supervision.
      </el-checkbox>
    </el-form-item>

    <el-form-item prop="membershipsOther">
      <el-checkbox
        v-model="form.membershipsOther"
        border
      >
        Ich verfüge über eine andere zertifizierte Ausbildung zum Coach.
      </el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'CAccountFormCoachSkillsVue',

  props: {
    temp: {
      type: Object,
      default: () => ({})
    },
    form: {
      type: Object,
      required: true
    }
  },

  inject: ['elForm'],

  methods: {
    handleTrainingChange () {
      this.form.documentsTraining = this.$refs.training.$refs.input.files[0]
      this.elForm.validateField('documentsTraining')
    },
    handleCertificateChange () {
      this.form.documentsCertificate = this.$refs.certificate.$refs.input.files[0]
      this.elForm.validateField('documentsCertificate')
    }
  }
}
</script>

<style lang="scss">
// Don’t scope this or it won’t apply
.account-form-coach-skills .el-input__inner[type="number"] {
  appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
}
</style>
